import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// @ts-ignore
import VueMask from 'v-mask';
import {formatDate, formatDateTime, formatPrice} from "@/utils";
import {BootstrapVue, VBModal} from 'bootstrap-vue'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
  faExternalLinkAlt,
  faAngleDown,
  faChartLine,
  faWallet,
  faTimes,
  faPen,
  faInfoCircle,
  faAngleLeft,
  faPaperclip,
  faCheck,
  faBars,
  faEye,
  faEyeSlash,
  faExclamation,
  faChevronRight,
  faUser,
  faBuilding,
  faFile,
  faChild,
  faIdCard,
  faPassport,
  faInfo,
  faSignOutAlt, faSpinner, faRedo, faDownload
} from "@fortawesome/free-solid-svg-icons";
import {faEnvelope, faListAlt, faFileAlt} from "@fortawesome/free-regular-svg-icons";
library.add(faExternalLinkAlt, faAngleDown, faEnvelope, faWallet, faListAlt, faWallet, faTimes, faInfoCircle, faPen);
library.add(faChartLine, faFileAlt, faAngleLeft, faPaperclip, faCheck, faBars, faEye, faEyeSlash, faExclamation, faChevronRight);
library.add(faUser, faBuilding, faFile, faChild, faIdCard, faPassport, faInfo, faSignOutAlt, faSpinner, faRedo, faDownload);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueMask);


// eslint-disable-next-line @typescript-eslint/no-var-requires
const companyTexts = require('./assets/texts/' + process.env.VUE_APP_TEXTS_FILE);

Vue.mixin({
  methods: {
    getCompanyText(key) {
      return companyTexts[key];
    },
    getLogoUrl() {
      return "images/logos/" + process.env.VUE_APP_LOGO_FILE;
    },
  }
});


export const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.filter("number", (number: number, maximumFractionDigits: number|null = 2) => {
  return formatPrice(number, maximumFractionDigits);
});
Vue.filter('date', (date: any) => {
  return formatDate(date);
});
Vue.filter('dateTime', (date: any) => {
  return formatDateTime(date);
});


export const publicPath = process.env.VUE_APP_PUBLIC_PATH ? process.env.VUE_APP_PUBLIC_PATH : '/';
